import React, { useMemo } from "react";
import { sanitizeContactAddressHtml } from "../../utils/institutionalPages";
import styles from "./style.module.css";

export default function ContactAddress({ html, compact = false, className = "" }) {
  const safe = useMemo(() => sanitizeContactAddressHtml(html, compact), [html, compact]);
  if (!safe) return null;
  return <div className={[styles.address, compact && styles.compact, className].filter(Boolean).join(" ")}
    dangerouslySetInnerHTML={{ __html: safe }} />;
}
